import { i18nFilter, translate } from "app/filters/i18nFilter";
import { abbrNumberFilter } from "app/filters/ngFilters";

import type { Axis, MinMaxValues } from "../types";

const i18n = i18nFilter();
export const X_AXIS_ID = "Affinity";
export const Y_AXIS_ID = "Traffic";

interface AxisConfig {
    id: string;
    name: string;
    tooltip: string;
    formatter: (value: number) => string;
    hidePill?: boolean;
    skipAlternateLabels?: boolean;
}

interface ScatterAxisConfig {
    xAxis: AxisConfig;
    yAxis: AxisConfig;
}

export const getAxisConfig = (): ScatterAxisConfig => ({
    xAxis: {
        id: X_AXIS_ID,
        name: translate("analysis.source.search.overview.search.competitors.xAxis.title"),
        tooltip: "analysis.source.search.overview.search.competitors.xAxis.tooltip",
        formatter: (value) =>
            i18n("analysis.competitors.search.table.scatter.tooltip.points", { data: Math.round(value) }),
        hidePill: true,
    },
    yAxis: {
        id: Y_AXIS_ID,
        name: translate("analysis.source.search.overview.search.competitors.organicsearchalltraffic.title"),
        tooltip: "analysis.source.search.overview.search.competitors.organicsearchalltraffic.tooltip",
        formatter: (value) =>
            i18n("analysis.competitors.search.table.scatter.tooltip.visits", {
                data: abbrNumberFilter()(value, true),
            }),
        skipAlternateLabels: true,
    },
});

interface XYConfigProps {
    axis: AxisConfig;
    mainSiteData: number;
}

export const getXYConfig = ({ axis, mainSiteData }: XYConfigProps) => ({
    name: axis.name,
    valueFormat: (x) => (axis.formatter ? axis.formatter(x) : x),
    highLabel: translate("conversion.scatter.high"),
    lowLabel: translate("conversion.scatter.low"),
    midValue: mainSiteData,
});

interface VectorConfigProps {
    axis: AxisConfig;
    minMaxValues: MinMaxValues;
}

export const getVectorConfig = ({ axis, minMaxValues }: VectorConfigProps): Axis => {
    const axisKey = axis.id === X_AXIS_ID ? "x" : "y";
    return {
        min: minMaxValues[axisKey]?.min ?? 0,
        max: minMaxValues[axisKey]?.max ?? 100,
        labels: {
            formatter: axis.formatter
                ? function () {
                      const index = this.axis.tickPositions.indexOf(this.value as number);

                      if (axis.skipAlternateLabels && index % 2 !== 0) {
                          return "";
                      }
                      return axis.formatter(this.value);
                  }
                : undefined,
        },
        title: axis.name,
        tooltip: axis.tooltip,
    };
};
